export default "__VITE_ASSET__0aea98eb__"